var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 0H2.875C2.38281 0 1.96094 0.328125 1.79688 0.75H0.8125C0.484375 0.75 0.25 1.00781 0.25 1.3125V7.6875C0.25 8.41406 0.835938 9 1.5625 9H13.1875C13.4922 9 13.75 8.76562 13.75 8.4375V0.5625C13.75 0.257812 13.4922 0 13.1875 0ZM1.375 7.6875V1.875H1.75V7.6875C1.75 7.80469 1.65625 7.875 1.5625 7.875C1.44531 7.875 1.375 7.80469 1.375 7.6875ZM12.625 7.875H2.85156C2.85156 7.82812 2.875 7.75781 2.875 7.6875V1.125H12.625V7.875ZM4.28125 5.0625H7.46875C7.60938 5.0625 7.75 4.94531 7.75 4.78125V2.53125C7.75 2.39062 7.60938 2.25 7.46875 2.25H4.28125C4.11719 2.25 4 2.39062 4 2.53125V4.78125C4 4.94531 4.11719 5.0625 4.28125 5.0625ZM4.9375 3.1875H6.8125V4.125H4.9375V3.1875ZM4 6.46875C4 6.63281 4.11719 6.75 4.28125 6.75H7.46875C7.60938 6.75 7.75 6.63281 7.75 6.46875V5.90625C7.75 5.76562 7.60938 5.625 7.46875 5.625H4.28125C4.11719 5.625 4 5.76562 4 5.90625V6.46875ZM8.5 6.46875C8.5 6.63281 8.61719 6.75 8.78125 6.75H11.2188C11.3594 6.75 11.5 6.63281 11.5 6.46875V5.90625C11.5 5.76562 11.3594 5.625 11.2188 5.625H8.78125C8.61719 5.625 8.5 5.76562 8.5 5.90625V6.46875ZM8.5 3.09375C8.5 3.25781 8.61719 3.375 8.78125 3.375H11.2188C11.3594 3.375 11.5 3.25781 11.5 3.09375V2.53125C11.5 2.39062 11.3594 2.25 11.2188 2.25H8.78125C8.61719 2.25 8.5 2.39062 8.5 2.53125V3.09375ZM8.5 4.78125C8.5 4.94531 8.61719 5.0625 8.78125 5.0625H11.2188C11.3594 5.0625 11.5 4.94531 11.5 4.78125V4.21875C11.5 4.07812 11.3594 3.9375 11.2188 3.9375H8.78125C8.61719 3.9375 8.5 4.07812 8.5 4.21875V4.78125Z",
    fill: "#0A3751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.60ed79ed07e785e607488168ddfd21c0.svg";
export { ForwardRef as ReactComponent };